import React, { memo, useCallback } from 'react';
import EditableItem from '../../EditableItem/EditableItem';
import { useDispatch } from 'react-redux';
import editDocumentActions from '../../store/actions/edit-document.actions';
import documentEditMode from '../../constants/documentEditMode';
import { ucFirst } from '../utils/ucFirst';

const StatusCell = memo(({ record, getPopupContainer = () => document.body }) => {
  const type = record.type && record.type.id;
  const dispatch = useDispatch();

  const openModal = useCallback((e) => {
    e.stopPropagation();
    dispatch(
      editDocumentActions.openModal({
        ...record,
        editMode: documentEditMode.STATUS,
      })
    );
  }, []);

  return (
    type && (
      <EditableItem
        editText='Изменить статус'
        itemText={ucFirst(record.status.name)}
        onClick={openModal}
        record={record}
        getPopupContainer={getPopupContainer}
      />
    )
  );
});

export default StatusCell;
